import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ConfigContext } from "../context/GlobalContext";
import { toast } from "react-toastify";
import { DeleteInvoice, EditProformaInvoice, EditQuotation } from "../data";
import { Languages } from "../Utils/Languages";
import * as actionType from "../context/actions";
import DeleteAuthUserDataInFirebase from "../data/Firebase/AgencyMember/DeleteAgencyMemberDataInFirebase";

const DeleteMemberView = ({ FirebaseId, targetUid }) => {

    const { state, dispatch } = useContext(ConfigContext)

    const [showModal, setShowModal] = useState(false);

    const handleDelete = async () => {

        try {

            // 🔎 Find invoice before deleting
            const { success } = await DeleteAuthUserDataInFirebase(state, dispatch, FirebaseId, targetUid);

            if (!success) {
                toast.error("Something went wrong");
                return;
            }

            toast.success("Member deleted successfully");
        } catch (err) {
            console.error("Delete error:", err);
            toast.error("Something went wrong");
        }

        setShowModal(false);
    };


    return (
        <>
            {/* Delete Button */}
            <Link
                onClick={(e) => {
                    if (!state?.USERID) {
                        e.preventDefault();
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    setShowModal(true);
                }}
                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
            >
                <Icon icon="mingcute:delete-2-line" />
            </Link>

            {/* Delete Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{Languages[state?.LANGUAGE]?.inoive_delete_conformation}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{"Are you sure want to remove access of this member?"}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {Languages[state?.LANGUAGE]?.cancel}

                    </Button>
                    <Button variant="danger" className="bg-danger" onClick={handleDelete}>
                        {Languages[state?.LANGUAGE]?.delete}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteMemberView